module.exports = __webpack_public_path__ + "kBVzUNvI_400x400.webp?c9b8da516f958432093a96fa2b6f34f3";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/kBVzUNvI_400x400.webp
// module id = 276
// module chunks = 0